
<template>

 <v-dialog max-width="600px" v-model="options.showEditDialog">
   
    <v-card>
      <v-card-title>
        <h2>Either edit code name or merge into another code</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" onSubmit="return false;">
          <v-layout row>
            <v-flex xs12>
              <v-text-field ref="firstField" v-if="options.showEditDialog" autofocus v-model="options.currentName" name='codeName' label="Code Name"
                :rules="[rules.required, rules.min]" /> <!-- autofocus ONLY works on 2nd+ opens with that v-if - a hack! -->
            </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs12>
                <div class="text-xs-left">
                <v-btn  flat outline color="black" @click='showMerge'>
                  <v-icon small left>arrow_right_alt</v-icon>
                 <span>Merge into another Code</span>
                </v-btn>               
                </div>
              </v-flex>
          </v-layout>
          <v-layout row wrap v-if='showingMerge'>
              <v-flex xs12 my-3 py-3>        
    
                      <div style="margin-top:-30px;border:1px solid white">
                        <div class="grey--text" style='text-align:left'>All the people assigned to the current code "{{code.name}}"" 
                          will be moved to the new code you choose, and the current code will cease to exist.
                         </div> 
                         <v-select box label="Merged into code" name='mcode' v-model="code.mergedToCodeId" item-text='v' item-value='id'
                          :items=data[options.currentCodeType]></v-select>
                        
                      </div>
                      <v-btn flat outline color="black" @click='hideMerge'>
                        <v-icon small left>cancel</v-icon>
                        <span>Cancel merge</span>
                      </v-btn> 

              </v-flex>
          </v-layout>
          <provenance-and-note v-bind:record="code"/>

          <v-layout row>
              <v-flex xs12>
                <div class="error" v-html="error"></div>
              </v-flex>
          </v-layout>

          <v-layout row>          
              <v-flex xs4>
              </v-flex>
              <v-flex xs4>
                <v-btn dark class="indigo darken-1" @click='editCode' :loading="loading"><v-icon left >save_alt</v-icon> {{editButtonPrompt}}</v-btn>
              </v-flex>
              <v-flex xs4>
              </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
 </v-dialog>
</template>        

<script>

import Panel from '@/components/Panel' ;
import CodeService from "@/services/CodeService" ;

export default {
  components: { Panel }, 
  props: {
    codes: null,
    options: null,
    data: null      // all the code types and code ids and vals
  },
  data () {
    return {
      rank: {},
      code: {  
        id: -1,
        type: -1,
        name: '',
        provenance: '',
        note: '',
        mergedToCodeId: -1
      },
      title: 'Edit code',
      error: null,
      message: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 3 || 'Minimum of 3 characters is required.'
      },
      mergeToRank: null,
      toRanks: [],
      isLoading: false,
      showingMerge: false,
      editButtonPrompt: "Edit Code Name",
      loading: false,
      showDialog: false
    }
  },

  async mounted () {
    console.log("in codeEdit mounted") ;
  },

  methods: {
    async editCode () {
      console.log("IN editCode") ; 

      if (!this.$refs.form.validate()) return ;

      this.error = null ;

      this.code.id = this.options.currentId ;
      this.code.type = this.codes[this.options.currentCode].code ;
      this.code.name = this.options.currentName ;

      console.log("CODE UPDATE TYPE merge " + this.showingMerge + ",  update obj= " + JSON.stringify(this.code)) ;
      if (this.showingMerge) {
        if (this.code.mergedToCodeId <= 0) {
          this.error = "Select a code to merge this rank into" ;
          return ;
        }
        console.log("mergeToCode=" + JSON.stringify(this.mergeToCode)) ;
        try {
          console.log("at 1") ;
          this.loading = true ;
          const response = await CodeService.mergeTo(this.code) ;
          console.log("at 2") ;
          console.log("mergeTo response: " + JSON.stringify(response)) ;

          // this.message = response.data.message
          console.log("success mergeTo, resp data=" + JSON.stringify(response.data)) ;
          this.options.showEditDialog = false ;
          this.$renderToastInParent(this, "Code " + this.code.name + " successfully merged and deleted") ;

          // remove the element with id = id

          const arr = this.data[this.options.currentCodeType] ;
          this.data[this.options.currentCodeType] = arr.filter(val => (val.id !== this.options.currentId)) ; ;
        
          // TODO update counts so they are accurate..
        }
        catch (err) {
          console.log("catch err:" + JSON.stringify(err)) ;
          // console.log("ee=" + err.response.data.error)
          this.error = err.response.data.error  ;
        }
        finally {
          this.loading = false ;
        }
        return ;
      }

      try {
        this.loading = true ;
        const response = await CodeService.edit(this.code) ;
        console.log("editCode response: " + JSON.stringify(response)) ;

        // this.message = response.data.message
        console.log("success edit, resp data=" + JSON.stringify(response.data)) ;
        this.options.showEditDialog = false ;        
        this.$renderToastInParent(this, "Code name successfully changed") ;

        this.data[this.options.currentCodeType].forEach(val => { if (val.id === this.options.currentId) val.v = this.options.currentName ; }) ;

        // this.$router.push('/rank/' + response.data.type + "/" + response.data.id + "?nonce=" + Math.random()) ;
      }
      catch (err) {
        console.log("catch err:" + JSON.stringify(err)) ;
        // console.log("ee=" + err.response.data.error)
        this.error = err.response.data.error  ;
      }
      finally {
        this.loading = false ;
      }
    },

    showMerge () {
      console.log("showMerge clicked") ;
      this.showingMerge = true ;
      this.editButtonPrompt = "Merge (and then delete) Code" ;
    },
    hideMerge () {
      this.showingMerge = false ;
      this.editButtonPrompt = "Edit Code Name" ;
      this.code.mergedToCodeId = -1 ;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CodeEdit.vue